import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { first } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { DevicesService } from 'src/app/services/devices.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { SearchPipe } from 'src/app/search.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginationComponent } from 'src/app/helpers/pagination/pagination.component';

class removingFilter {
  present: any;
  booked: any;
  annotated: any;
  controlled: any;
}
@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css'],
  standalone: true,
  imports: [TranslateModule, FormsModule, SearchPipe, NgxPaginationModule, PaginationComponent]
})
export class DeviceComponent implements OnInit {

  @ViewChild('alert_message') alertTemplate: TemplateRef<any>;
  Dummydevices: any = []
  alertMessage: any;

  //Modal
  modalRef!: MatDialogRef<any>;

  devicePageSize: any;
  confirmRemove = { value: true };
  filteredDevices: any;
  devicesBySerial: any = {};
  search: any;
  removingFilters: any = new removingFilter();

  // showFilters: boolean = false;
  page = 1;
  _serial: any;


  removeDevicesSearch: any;
  removeDevicesFilteredDevice: any;
  removeDeviceSerial: any;

  // removingFilterOptions = ["True", "False", "Any"];
  deviceFields =
    'model,' +
    'serial,' +
    'version,' +
    'display.height,' +
    'display.width,' +
    'manufacturer,' +
    'sdk,' +
    'abi,' +
    'cpuPlatform,' +
    'openGLESVersion,' +
    'marketName,' +
    'phone.imei,' +
    'provider.name,' +
    'group.originName';

  devices: any[] = [];
  itemsPerPageOptions = [
    { name: '1', value: 1 }
    , { name: '5', value: 5 }
    , { name: '10', value: 10 }
    , { name: '20', value: 20 }
    , { name: '50', value: 50 }
    , { name: '100', value: 100 }
    , { name: '200', value: 200 }
    , { name: '500', value: 500 }
    , { name: '1000', value: 1000 }
    , { name: '*', value: 0 }
  ];

  constructor(
    private commonService: CommonService,
    private devicesService: DevicesService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.initScope()

    //default filter
    this.removingFilters.present = "False";
    this.removingFilters.booked = "Any";
    this.removingFilters.annotated = "Any";
    this.removingFilters.controlled = "True";

    this.devicePageSize = 10;
    // Example: Fetch devices and add combined string property
    this.devices = this.devices.map(device => ({
      ...device,
      combinedString: `${device.manufacturer} ${device.model} (${device.marketName})`
    }));

  }

  onSearch(searchData: any) {
    this.search = searchData;
    this.page = 1;
  }

  onItemPerPageChange(changedItemPerPage: any) {
    this.devicePageSize = changedItemPerPage;
    this.page = 1;
  }

  onNextPageChange(nextPage: number) {
    this.page = nextPage;
  }

  publishDevice(device: any) {
    if (!device.model) {
      device.display = {}
    }
    else {
      device.displayStr = device.display.width + 'x' + device.display.height
    }
    for (let i in device) {
      if (device[i] === null) {
        device[i] = ''
      }
    }
    return device
  }

  addDevice(device: any, timeStamp: any) {
    return this.commonService.add(
      this.devices
      , this.devicesBySerial
      , device
      , 'serial'
      , timeStamp)
  }

  updateDevice(device, timeStamp) {
    return this.commonService.update(
      this.devices
      , this.devicesBySerial
      , device
      , 'serial'
      , timeStamp)
  }

  deleteDevice(serial: any, timeStamp: any) {
    return this.commonService.delete(
      this.devices
      , this.devicesBySerial
      , serial
      , timeStamp)
  }

  initScope() {
    // this.devicesService.getOboeDevices('user', this.deviceFields, (device) => {
    //   this.addDevice(this.publishDevice(device), -1)
    // })
    this.devicesService.getOboeDevices('user', this.deviceFields).pipe(first()).subscribe((res: any) => {
      if (res.success == true || res.success == "true") {
        let devices: any[] = res.devices;




        devices.forEach((object) => {
          this.addDevice(this.publishDevice(object), -1);
        })

        // res.devices.forEach(data =>{
        //   let Dummy 
        // Dummy =data.manufacturer + ' ' + data.model + ' (' + data.marketName +
        //   ')' 
        //  this.Dummydevices.push(Dummy)
        // })

      }
    })


  }

  remove(serial?: any, template?: TemplateRef<any>) {
    this._serial = serial;
    this.modalRef = this.dialog.open(template, { width: '300px' });

  }

  removeDevice() {
    this.devicesService.removeDevice(this._serial, this.removingFilters).pipe(first()).subscribe((res: any) => {
      if (res.success == true || res.success == "true") {
        this.devices = this.devices.filter(device => device.serial !== this._serial);

        delete this.devicesBySerial[this._serial];

        this.cancelRequest();

        this.openAlertMod(this.alertTemplate, res.description);
      }
    });
  }



  removeDevices(search?: any, filteredDevices?: any, askConfirmation?: any, template?: TemplateRef<any>) {
    this.cancelRequest();
    let _search = search;
    let _filteredDevices = filteredDevices;

    if (this.confirmRemove.value) {
      _search = this.removeDevicesSearch;
      _filteredDevices = this.removeDevicesFilteredDevice;
    }

    let removeDevices = () => {

      this.devicesService.removeDevices(this.removingFilters, undefined).pipe(first()).subscribe((res: any) => {
        if (res.success == true || res.success == "true") {
          this.openAlertMod(this.alertTemplate, res.description);
          // this.devices=[]
          //ask to sir devices
        }
      });
    }

    if (askConfirmation) {
      this.removeDevicesSearch = search;
      this.removeDevicesFilteredDevice = filteredDevices;
      this.modalRef = this.dialog.open(template, { width: '300px' });
    } else {
      removeDevices()
    }
  }

  removeFilters() {
    this.removingFilters.present = "False";
    this.removingFilters.booked = "Any";
    this.removingFilters.annotated = "Any";
    this.removingFilters.controlled = "True";
  }

  // $scope.$on('user.settings.devices.created', function(event, message) {
  //   addDevice(publishDevice(message.device), message.timeStamp)
  // })

  // $scope.$on('user.settings.devices.deleted', function(event, message) {
  //   deleteDevice(message.device.serial, message.timeStamp)
  // })

  // $scope.$on('user.settings.devices.updated', function(event, message) {
  //   updateDevice(publishDevice(message.device), message.timeStamp)
  // })

  //pagination 	
  handlePageChange(event: any) {
    this.page = event.pageIndex + 1;
  }

  // Modals
  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.alertMessage = message;
    setTimeout(() => {
      this.modalRef.close();
      this.alertMessage = "";
    }, 2000)
  }

  cancelRequest() {
    this.modalRef.close();
  }

}
